import { createSlice } from '@reduxjs/toolkit';

const groupMemberSlice = createSlice({
  name: 'groupMembers',
  initialState: {
    groupMembers: [],
    dataValid: false,
    group: {}
  },
  reducers: {
    setGroupMembers(state, action) {
        if (!action || !action.payload || !action.payload.groupMembers) {
          state.groupMembers = [];
        } else {
          state.groupMembers = action.payload.groupMembers;
          state.dataValid = !!action.payload.dataValid;
        }
    },
    clearGroupMembers(state, action){
      state.groupMembers = [];
      state.dataValid = true;
      state.group = {};
    },
    patchSkillLevels(state, action) {
      if (!action || !action.payload || !action.payload.skillLevels) {
        state.dataValid = false;
        return;
      }
      if (!state.groupMembers) return;

      state.dataValid = !!action.payload.dataValid;

      action.payload.skillLevels.forEach(updatedUserLevels => {
        if (!updatedUserLevels) return;
        if (!updatedUserLevels.userId) return;
        if (!updatedUserLevels.skillLevels && !updatedUserLevels.removedSkills) return;

//console.log("--- Update User Levels: " + JSON.stringify(updatedUserLevels));
//console.log("--- Group Members: " + JSON.stringify(state.groupMembers));
        let groupMember = state.groupMembers.find(item => item.id === updatedUserLevels.userId);
console.log("---GroupMember Slice - patchSkillLevels");
        if(!groupMember) return;
console.log("---GroupMember Slice - patchSkillLevels - GroupMemberFound");


        if(updatedUserLevels.skillLevels){
          if (!groupMember.skills) {
            groupMember.skills = updatedUserLevels.skillLevels;
          } else {
            updatedUserLevels.skillLevels.forEach(updatedLevel => {
              let level = groupMember.skills.find(item => item.id === updatedLevel.id);
              if (!level) {
                level = {
                  id: updatedLevel.id,
                  proficiency: updatedLevel.proficiency,
                }
                groupMember.skills.push(level);
              } else {
                level.proficiency = updatedLevel.proficiency;
              }
            });
          }
        }

        if(updatedUserLevels.removedSkills){
          updatedUserLevels.removedSkills.forEach(removedSkill => {

            if(groupMember.skills){
              //Remove skill from list
              let index = groupMember.skills.findIndex(item => item.id === removedSkill.id);

              if(index >= 0){
                groupMember.skills.splice(index, 1);
              }
            }
          });
        }
      });
    },
    patchLanguageLevels(state, action) {
      if (!action || !action.payload || !action.payload.skillLevels) {
        state.dataValid = false;
        return;
      }

      state.dataValid = !!action.payload.dataValid;

      if (!state.groupMembers) return;

      action.payload.skillLevels.forEach(updatedUserLevels => {
        if (!updatedUserLevels) return;
        if (!updatedUserLevels.userId) return;
        if (!updatedUserLevels.skillLevels && !updatedUserLevels.removedSkills) return;

//console.log("--- Update User Levels: " + JSON.stringify(updatedUserLevels));
//console.log("--- Group Members: " + JSON.stringify(state.groupMembers));
        let groupMember = state.groupMembers.find(item => item.id === updatedUserLevels.userId);

        if(!groupMember) return;

        if(updatedUserLevels.skillLevels){
          if (!groupMember.languages) {
            groupMember.languages = updatedUserLevels.skillLevels;
          } else {
            updatedUserLevels.skillLevels.forEach(updatedLevel => {
              let level = groupMember.languages.find(item => item.id === updatedLevel.id);
              if (!level) {
                level = {
                  id: updatedLevel.id,
                  proficiency: updatedLevel.proficiency,
                }
                groupMember.languages.push(level);
              } else {
                level.proficiency = updatedLevel.proficiency;
              }

            });
          }
        }

        if(updatedUserLevels.removedSkills){
          updatedUserLevels.removedSkills.forEach(removedSkill => {

            if(groupMember.languages){
              //Remove skill from list
              let index = groupMember.languages.findIndex(item => item.id === removedSkill.id);
              if(index >= 0){
                groupMember.languages.splice(index, 1);
              }
            }
          });
        }

      });

    },
    setGroup(state, action){
      if (!action || !action.payload) {
        state.group = {};
      } else {
        state.group = action.payload;
//        state.dataValid = !!action.payload.dataValid;
      }
    },
    invalidateData(state, action) {
      state.dataValid = false;
    }
  },
});

export const groupMemberActions = groupMemberSlice.actions;

export default groupMemberSlice;